<template>
  <div class="card" style="position:relative">
    <b-button
      @click="selectedMap = false"
      v-if="selectedMap"
      style="position: absolute; top: 4%; left: 3%; z-index: 10;"
      type="is-dark"
      size="is-small"
      outlined
      >Back</b-button
    >

    <div class="box has-text-centered" v-if="loading">
      Requesting seat maps...
    </div>
    <SeatMap
      v-else-if="selectedMap"
      :seatmap="selectedMap"
      :preview="preview"
      @selected="selectSeat"
      :passenger="passenger"
    ></SeatMap>
    <div class="box wdt" v-else>
      <div class="mb-5">
        <button
          type="button"
          class="delete is-pulled-right"
          @click="$emit('close')"
        />
        <h1 class="is-size-3 ">Select flight</h1>
      </div>
      <div v-if="flights.length == 1">
        <div
          v-for="flight in flights[0].legs"
          :key="flight.legIndex"
          class="mb-5"
        >
          <div class="columns is-mobile" style="width: 100%;">
            <div class="column is-7">
              <h1 class="is-size-3">
                {{ flight.departingAirport }} - {{ flight.arrivingAirport }}
              </h1>
              <h2 class="is-size-5 has-text-grey">
                Flight #{{ flight.marketingAirline.code
                }}{{ flight.flightNumber }}
              </h2>
              <h3 class="is-size-6 has-text-grey">
                Departing {{ flight.departingAt.date | formatDate }}
              </h3>
              <p></p>
            </div>
            <div class="column is-5">
              <div v-if="!flight.selectedSeat" style="margin-top: 35%;">
                <b-button
                  v-if="
                    seatMaps[buildIndex(0, flight.legIndex - 1)]
                      .seatsGroupedByRow
                  "
                  class="is-block"
                  style="margin: auto;"
                  size="is-small"
                  @click="goToSeatMap(buildIndex(0, flight.legIndex - 1))"
                  type="is-primary"
                  outlined
                  expanded
                  ><div v-if="preview">
                    View Seats
                  </div>
                  <div v-else>
                    Select Seat
                  </div></b-button
                >
                <b-button
                  v-else
                  :disabled="true"
                  type="is-dark"
                  size="is-small"
                  expanded
                  >Seat map unavailable</b-button
                >
              </div>
              <div v-else style="margin-top: 20%;">
                <div style="margin-bottom: 5px;">
                  <h1 class="is-size-6">
                    Selected seat:
                    <b class="is-size-5">{{ flight.selectedSeat.id }}</b>
                  </h1>
                </div>
                <b-button
                  class="is-block"
                  style="margin: auto;"
                  size="is-small"
                  @click="goToSeatMap(buildIndex(0, flight.legIndex - 1))"
                  type="is-primary"
                  outlined
                  expanded
                  >Edit Selection</b-button
                >
                <!-- <a style="margin:auto;" @click="goToSeatMap(flight.legIndex - 1)"> Edit Selection </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs v-else v-model="tab" type="is-boxed">
        <b-tab-item
          v-for="journey in flights"
          :key="journey.uniqueKey"
          :label="journey.from + ' - ' + journey.to"
        >
          <div
            v-for="flight in journey.legs"
            :key="flight.legIndex"
            class="mb-5"
          >
            <div class="columns is-mobile" style="width: 100%;">
              <div class="column is-7">
                <h1 class="is-size-3">
                  {{ flight.departingAirport }} - {{ flight.arrivingAirport }}
                </h1>
                <h2 class="is-size-5 has-text-grey">
                  Flight #{{ flight.marketingAirline.code
                  }}{{ flight.flightNumber }}
                </h2>
                <h3 class="is-size-6 has-text-grey">
                  Departing {{ flight.departingAt.date | formatDate }}
                </h3>
                <p></p>
              </div>
              <div class="column is-5">
                <div v-if="!flight.selectedSeat" style="margin-top: 35%;">
                  <b-button
                    v-if="
                      seatMaps[
                        buildIndex(
                          journey.segmentIndex - 1,
                          flight.legIndex - 1
                        )
                      ].seatsGroupedByRow
                    "
                    class="is-block"
                    style="margin: auto;"
                    size="is-small"
                    @click="
                      goToSeatMap(
                        buildIndex(
                          journey.segmentIndex - 1,
                          flight.legIndex - 1
                        )
                      )
                    "
                    type="is-primary"
                    outlined
                    expanded
                    ><div v-if="preview">
                      View Seats
                    </div>
                    <div v-else>
                      Select Seat
                    </div></b-button
                  >
                  <b-button
                    v-else
                    :disabled="true"
                    type="is-dark"
                    size="is-small"
                    expanded
                    >Seat map unavailable</b-button
                  >
                </div>
                <div v-else style="margin-top: 20%;">
                  <div style="margin-bottom: 5px;">
                    <h1 class="is-size-6">
                      Selected seat:
                      <b class="is-size-5">{{ flight.selectedSeat.id }}</b>
                    </h1>
                  </div>
                  <b-button
                    class="is-block"
                    style="margin: auto;"
                    size="is-small"
                    @click="
                      goToSeatMap(
                        buildIndex(
                          journey.segmentIndex - 1,
                          flight.legIndex - 1
                        )
                      )
                    "
                    type="is-primary"
                    outlined
                    expanded
                    >Edit Selection</b-button
                  >
                  <!-- <a style="margin:auto;" @click="goToSeatMap(flight.legIndex - 1)"> Edit Selection </a> -->
                </div>
              </div>
            </div>
          </div>
        </b-tab-item>
        <!-- <b-tab-item label="Music" icon="library-music"></b-tab-item>
            <b-tab-item label="Videos" icon="video"></b-tab-item> -->
      </b-tabs>

      <div v-if="!preview" class="mt-6">
        <b-button
          class="is-block"
          style="margin: auto;"
          @click="$emit('close')"
          type="is-primary"
          expanded
          >Close Seat Viewer</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// import Row from './Row.vue'
// import FlightDetails from './FlightDetails'
import SeatMap from "./SeatMap.vue";
export default {
  components: {
    SeatMap,
  },
  props: {
    activeTab: Number,
    flightProp: [Array, Object],
    preview: Boolean,
    guestIndex: Number,
  },
  data: function() {
    return {
      name: "seatMapMenu",
      seatMaps: {},
      tab: 1,
      selectedMap: false,
      loading: true,
      passenger: {
        id: 1,
        name: "",
      },
      //aisleLeftColumn: null,
      //aisleRightColumn: null
    };
  },
  computed: {
    flights() {
      if (this.flightProp) {
        return this.flightProp;
      } else {
        return this.$store.state.bookTravel.result.flight.journeys;
      }
    },
  },
  methods: {
    selectSeat(selectedSeat) {
      console.log(selectedSeat);
      var indices = this.selectedMap.segmentIndex.split(".");
      selectedSeat.journeyIndex = indices[0];
      selectedSeat.legIndex = indices[1];

      if (typeof this.guestIndex !== "undefined") {
        let payload = {};
        payload.guestIndex = this.guestIndex;
        payload.selectedSeat = selectedSeat;
        this.$store.commit("bookTravel/ADD_SEAT_GUEST", payload);
        console.log("is a guest");
        console.log(payload);
      } else {
        this.$store.commit("bookTravel/ADD_SEAT", selectedSeat);
        console.log("is a primary traveler");
        console.log(selectedSeat);
      }

      this.selectedMap = false;
    },
    goToSeatMap(i) {
      this.selectedMap = this.seatMaps[i];
      this.selectedMap.segmentIndex = i;
      // console.log(this.selectedMap)
    },
    buildIndex(j, i) {
      return j + "." + i;
    },
    buildRaw(j, i) {
      var data = {
        departureAirport: this.flights[j].legs[i].departingAirport,
        arrivalAirport: this.flights[j].legs[i].arrivingAirport,
        airlineCode: this.flights[j].legs[i].marketingAirline.code,
        flightNumber: this.flights[j].legs[i].flightNumber,
        departureDate: this.flights[j].legs[i].departingAt.date,
        bookingClass: this.flights[j].legs[i].fareInfo.bookingClass,
      };
      var program = this.findProgramCode(
        this.passenger.programs,
        data.airlineCode
      );
      if (program) {
        data.traveler = {
          firstName: this.passenger.firstName,
          lastName: this.passenger.lastName,
          frequentFlyer: {
            company: data.airlineCode,
            number: program,
          },
        };
      }
      // console.log(data)
      return data;
    },
    findProgramCode(programs, provider) {
      if (programs) {
        for (var i = 0; i < programs.length; i++) {
          if (programs[i].providerCode == provider) {
            return programs[i].accountNumber;
          }
        }
      }
      return false;
    },
    getAllMaps(j, i) {
      var raw;
      if (i == this.flights[j].legsCount) {
        if (j == this.flights.length - 1) {
          this.loading = false;
          // console.log(this.seatMaps)
        } else {
          this.getAllMaps(j + 1, 0);
          // raw = this.buildRaw(j, i)
          // this.$app.huddleLabsServerCall('amadeus/air/seat-map', raw)
          //   .then(result => {this.seatMaps[j + '.' + i] = result; })
        }
      } else {
        raw = this.buildRaw(j, i);
        this.$app
          .huddleLabsServerCall("amadeus/air/seat-map", raw)
          .then((result) => {
            this.seatMaps[j + "." + i] = result;
            this.getAllMaps(j, i + 1);
          });
      }
    },
    async getSeatmap(raw, i) {
      //this.loading = true

      this.$app
        .huddleLabsServerCall("amadeus/air/seat-map", raw)
        .then((result) => {
          this.seatMaps[i] = result;
        });
    },
  },
  mounted() {
    let profile;
    if (typeof this.guestIndex !== "undefined") {
      profile = this.$store.state.bookTravel.guests[this.guestIndex].profile;
    } else {
      profile = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    }

    // console.log(profile)
    this.passenger.programs = profile.travelerPrograms;
    this.passenger.name = profile.firstName + " " + profile.lastName;
    this.passenger.firstName = profile.firstName;
    this.passenger.lastName = profile.lastName;
    // console.log(this.activeTab)
    this.tab = this.activeTab;
    this.getAllMaps(0, 0);
  },
};
</script>

<style scoped>
.seatmap-container {
  display: inline-block;
  overflow-y: scroll;
  max-height: 400px;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
